import WorthyApi from "lib/api/worthyApi";
import rootStore from "reducers";
import { showLoader, hideLoader } from "actions/loader";

export const REQUEST_HELP_CALL = Symbol("REQUEST_HELP_CALL");

export function requestHelpCall(params) {
    rootStore.dispatch(showLoader());
    let request = WorthyApi.helpCall(
        Object.assign({}, params, {
            itemId: rootStore.getState().Item
                ? rootStore.getState().Item.id
                : null,
        })
    )
        .then((response) => {
            rootStore.dispatch(hideLoader());
            return response;
        })
        .catch((error) => {
            rootStore.dispatch(hideLoader());
            throw error;
        });

    return {
        type: REQUEST_HELP_CALL,
        payload: request,
    };
}
